export const urlRegex =
  /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const currencyCodes = [
  "USD",
  "EUR",
  "GBP",
  "CAD",
  "AUD",
  "INR",
  "JPY",
  "CNY",
] as const;
export const MAX_RESUME_FILE_SIZE = 5 * 1024 * 1024; // 5MB

export enum Role {
  FREELANCER = 'freelancer',
  ENTERPRISE = 'Enterprise',
}
export const ACCEPTED_FILE_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
export const CATEGORIES = [
  "Web Development",
  "Mobile App Development",
  "UI/UX Design",
  "Graphic Design",
  "Content Writing",
  "Digital Marketing",
  "Data Analysis",
  "Video Editing",
  "Audio Production",
  "AI & Machine Learning",
  "Blockchain Development",
  "Full-Stack Development",
  "Human Resources",
];
export const Skills = [
  "JavaScript",
  "HTML5",
  "Java",
  "Python",
  "PHP",
  "ReactJS",
  "NodeJS",
  "React-Router-Dom",
  "Material UI",
  "Bootstrap",
  "Axios",
  "Rest API",
  "Express.js",
  "CSS",
  "MongoDB",
  "MySQL",
  "Git",
  "GitHub",
  "VS-Code",
  "Postman",
  "Linux",
  "Windows",
  "Python",
  "JavaScript",
  "React",
  "Node.js",
  "SQL",
  "AWS",
  "Docker",
  "Agile Methodology"
];
export const JOB_APPLICATION_STATUS = ["pending", "accepted", "rejected", "withdrawn", "interview"]
export const APPLICATION_STATUS_MAP: Record<number, string> = {
  1: "Applied",
  2: "Viewed",
  3: "Interview",
  4: "Contract Initiated",
  5: "In Progress",
  6: "On Hold",
  7: "Completed",
  8: "Paid",
  9: "Withdrawn",
};
export const DURATION_TYPE = [
  { value: "1", label: "week", heading:"Week"},
  { value: "2", label: "month", heading:"Month" },
];
export const SKILLS_LIST = [
  // Web Development
  "React",
  "Angular",
  "Vue.js",
  "Node.js",
  "Express.js",
  "Django",
  "Flask",
  "Ruby on Rails",
  "PHP",
  "Laravel",
  "ASP.NET",
  "JavaScript",
  "TypeScript",
  "HTML",
  "CSS",
  "Tailwind CSS",
  "Bootstrap",
  "GraphQL",
  "REST API",
  "Next.js",
  "Gatsby",
  // Mobile Development
  "React Native",
  "Flutter",
  "Swift",
  "Kotlin",
  "Ionic",
  "Xamarin",
  "Android Development",
  "iOS Development",
  // Game Development
  "Unity",
  "Unreal Engine",
  "Cocos2d-x",
  "Godot",
  "C++",
  "C#",
  "Game Design",
  "3D Modeling",
  "Animation",
  // Human Resources
  "Recruitment",
  "Talent Acquisition",
  "Employee Training",
  "HR Management",
  "Payroll Management",
  "Performance Management",
  "Organizational Development",
  // UI/UX Design
  "Figma",
  "Sketch",
  "Adobe XD",
  "InVision",
  "User Research",
  "Wireframing",
  "Prototyping",
  "Interaction Design",
  "Usability Testing",
  // Content Writing
  "Copywriting",
  "Technical Writing",
  "Blog Writing",
  "SEO Writing",
  "Content Strategy",
  "Editing",
  "Proofreading",
  // Digital Marketing
  "SEO",
  "SEM",
  "Social Media Marketing",
  "Email Marketing",
  "Content Marketing",
  "PPC Advertising",
  "Google Analytics",
  "Google Ads",
  "Facebook Ads",
  // Video Editing
  "Adobe Premiere Pro",
  "Final Cut Pro",
  "DaVinci Resolve",
  "After Effects",
  "Motion Graphics",
  "Color Grading",
  "Video Production",
  // Other
  "Project Management",
  "Agile Methodology",
  "Scrum",
  "DevOps",
  "AWS",
  "Azure",
  "Docker",
  "Kubernetes",
  "Machine Learning",
  "Data Analysis",
  "Python",
  "Java",
  "SQL",
  "NoSQL",
  "Cybersecurity",
];

export const JOB_APPLICATION_STATUS_WITH_KEY = [
    { value: "1", label: "Pending" },
    { value: "2", label: "Active" },
    { value: "3", label: "In Progress" },
    { value: "4", label: "Completed" },
    { value: "5", label: "Cancelled" },
];

export const CURRENCY_OPTIONS = [
    { value: "1", label: "US Dollar (USD)" },
    { value: "2", label: "Euro (EUR)" },
    { value: "3", label: "Indian Rupee (INR)" },
    { value: "4", label: "British Pound (GBP)" },
];

export const CRYPTO_CURRENCY_OPTIONS = [
    // { value: "1", label: "US Dollar Tether (USDT)" },
    { value: "2", label: "US Dollar Coin (USDC)" }
];

export const DURATIONUNIT_LABEL = {
    "days": 1,
    "day": 1,
    "weeks": 2,
    "week": 2,
    "months": 3,
    "month": 3,
};

export const PAYMENT_METHOD_OPTIONS =  [
    // { value: "paypal", label: "Paypal" },
    { value: "crypto", label: "Cryptocurrency" },
];

export const CONTRACT_STATUS_KEY_WTIH_VALUE = {
  1 : 'pending',
  2 : 'accepted',
  3 : 'in-progress',
  4 : 'completed',
  5 : 'cancelled',
  6 : 'rejected',
}

export const MILESTONE_STATUS_WITH_KEY = [
    { value: "1", label: "Initiated" },
    { value: "2", label: "In Progress" },
    { value: "3", label: "Submitted" },
    // { value: "4", label: "Reviewed" },
    { value: "5", label: "Need Rework" },
    // { value: "6", label: "Rejected" },
    { value: "7", label: "Approved" },
];

export const MILESTONE_STATUS_KEY_WTIH_VALUE = {
  1 : 'initiated',
  2 : 'in-progress',
  3 : 'submitted',
  4 : 'reviewed',
  5 : 'needs-rework',
  6 : 'rejected',
  7 : 'approved',
}

export const APPLICATION_STATUS_WITH_VALUE = [
    // { value: "1", label: "Applied" },
    { value: "2", label: "Viewed" },
    { value: "3", label: "Interview" },
    { value: "4", label: "Accepted" },
    { value: "5", label: "On Hold" },
    { value: "6", label: "Rejected" },
    // { value: "7", label: "Withdrawn" },
];

export const APPLICATION_STATUS_WITH_KEY_MAPPING = {
  1: "Applied",
  2: "Viewed",
  3: "Interview",
  4: "Accepted",
  5: "On Hold",
  6: "Rejected",
  7: "Withdrawn",
};

export const CONTRACT_STATUS_KEY_WTIH_LABEL = {
  1 : 'Pending',
  2 : 'Accepted',
  3 : 'In Progress',
  4 : 'Completed',
  5 : 'Cancelled',
  6 : 'Rejected',
}